import { makeStyles } from '@material-ui/core/styles';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import LinearProgress from "@material-ui/core/LinearProgress/LinearProgress";
import React, { useState, useEffect } from 'react';
import AlertTitle from "@material-ui/lab/AlertTitle/AlertTitle";
import Alert from "@material-ui/lab/Alert/Alert";
import {SelectedItems} from "./SelectedItems";
import {ItemTile} from "./ItemTile";
import Typography from "@material-ui/core/Typography/Typography";
import {ListItems} from "./Components/List/ListItems";

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        overflow: 'hidden',
        width: '100%',
    },
    gridList: {
        // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
        transform: 'translateZ(0)',
        width: '100%'
    },
    icon: {
        color: 'white',
    },
    tile: {
    },
    otherCarsTitle: {
        margin: '10px 0'
    },
    otherCarsLabel: {
        width:'100%',
        marginLeft: 20
    },
    noResults: {
        width: '100%',
        marginTop: 10,
        ['@media (max-width:500px)']: {
            margin: '10px 6px',
        },
    }
}));

const useStyles1 = makeStyles({
    tile: {
        background: '#eee'
    },
}, { name: 'MuiGridListTile' });

let allData = {0:[], 1:[], 2:[], 3:[], 4:[], 5:[], 6:[], 7:[]};
let byYear = {0:{items:{}, count:0}, 1:{items:{}, count:0}, 2:{items:{}, count:0}, 3:{items:{}, count:0},
    4:{items:{}, count:0}, 5:{items:{}, count:0}, 6:{items:{}, count:0}, 7:{items:{}, count:0}};
let snLoaded = {0:{},1:{},2:{},3:{},4:{},5:{},6:{},7:{}};
let search = {0:null, 1:null, 2:null, 3:null, 4:null, 5:null, 6:null, 7:null};

export default function CarList(props) {
    const classes = useStyles();
    useStyles1();

    const [windowWidth, setWindowWidth] = React.useState(window.outerWidth);

    const contRef = React.createRef();

    const isBottom = (el) => {
        return parseInt(el.getBoundingClientRect().bottom) <= window.innerHeight;
    };


    /*const trackScrolling = () => {
        const wrappedElement = contRef.current;
        if (wrappedElement && isBottom(wrappedElement)) {
            console.log('header bottom reached', props.scrollingAutoload);
            document.removeEventListener('scroll', trackScrolling);
            if (props.scrollingAutoload) {
                props.setOffset(allData[props.listKey].length);
            }
        }
    };*/

    const updateWindowWidth = () => {
        setWindowWidth(window.innerWidth);
    };

    useEffect(() => {
        // Update the document title using the browser API
        //document.removeEventListener('scroll', trackScrolling);
        //document.addEventListener('scroll', trackScrolling);
        window.addEventListener('resize', updateWindowWidth);
    });

    if (search[props.listKey] !== props.search) {
        search[props.listKey] = props.search;
        allData[props.listKey] = [];
        snLoaded[props.listKey] = {};
        //props.setOffset(0);
        byYear = {0:{items:{}, count:0}, 1:{items:{}, count:0}, 2:{items:{}, count:0}, 3:{items:{}, count:0},
            4:{items:{}, count:0}, 5:{items:{}, count:0}, 6:{items:{}, count:0}, 7:{items:{}, count:0}};
    }


    const yearItems = byYear[props.listKey]['items'];
    if (props.items) {
        allData[props.listKey] = [];
        snLoaded[props.listKey] = [];

        const bY = byYear[props.listKey];
        props.items.map((item) => {

                if (!yearItems['s'+item.year] && bY['count'] < props.yearCount) {
                    yearItems['s'+item.year] = item;
                    bY['count']++;
                } else if (!snLoaded[props.listKey][item.sn]) {
                    allData[props.listKey].push(item);
                }

            snLoaded[props.listKey][item.sn] = true;
        });
    }

    const isMobile = props.isMobile;

    let yearItemsValues = Object.values(yearItems);

    yearItemsValues = yearItemsValues.concat(allData[props.listKey]);


    console.log('checking', yearItemsValues.length, props.loading, props.quietMode);
    return (
        <>
            <div className={classes.root} ref={contRef}>
                {yearItemsValues ?
                <ListItems items={yearItemsValues} isMobile={isMobile} handleClick={props.handleClick}
                    returnRoute={props.returnRoute} size={props.size} filter={props.filter}/> : null}
            </div>

            {yearItemsValues.length === 0 && !props.loading && !props.quietMode ?
                <Alert className={classes.noResults} severity="info">
                <AlertTitle>{props.noResultsMessage ? props.noResultsMessage : 'No Results. Please change your search.'}</AlertTitle>
            </Alert> : ''}
            {props.loading ? <LinearProgress /> : ''}
        </>
    );
}